import React from "react";
import { Container } from "react-bootstrap";

const First = () => {
  return (
    <>
      <section className="first-webDevelopment-section">
        <Container>
          <div className="page-title text-center">
            <h1>AI & IoT Development</h1>
            <div className="sub-info">
              <h3 className="h3">
                Evaluate business with smart IoT monitoring.
              </h3>
              <p>
                Our Technologies provide software solutions that solve complex
                industry problems. We create extensive infrastructure solutions
                where everything from devices to data centres are interconnected
                seamlessly.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
